import React from 'react'
import { Button, Modal } from 'react-bootstrap'

import i18n from 'live/services/i18n'

import { RoundedModal } from 'plugin-codaf-risk-ext-bowtie/generic'

import { ImportBody, ImportFooter, TextContainer } from './styles'

interface IProps {
    show: boolean
    handleClose: () => void
    submit: (k: File) => Promise<void>
    type: 'risk-diagram' | 'barrier' | 'bowtie'
    files: FileList
    setFiles: (k: FileList) => void
}

export const ImportDataModal: React.FC<IProps> = ({ show, handleClose, submit, type, files, setFiles }) => {
    const openImportGuidePDF = (): void => {
        window.open('/content/plugin-codaf-risk-ext-bowtie/RDBarrierImportGuide.pdf')
    }

    const riskDiagramText: JSX.Element = (
        <TextContainer>
            <div>{i18n('You are about to import risk diagram data.')}</div>
            <div>
                {i18n(
                    'Please consider that importing data is a process that needs to be done thoroughlly or it will result in an error.'
                )}
            </div>
            <div>
                {i18n('We advise you to read the ')}
                <a onClick={openImportGuidePDF}>{i18n('Import Guide')}</a>.
            </div>
        </TextContainer>
    )

    const barrierText: JSX.Element = (
        <TextContainer>
            <div>{i18n('You are about to import barrier data.')}</div>
            <div>
                {i18n(
                    'Please consider that importing data is a process that needs to be done thoroughlly or it will result in an error.'
                )}
            </div>
            <div>
                {i18n('We advise you to read the ')}
                <a onClick={openImportGuidePDF}>{i18n('Import Guide')}</a>.
            </div>
        </TextContainer>
    )

    return (
        <RoundedModal show={show} onHide={handleClose} aria-labelledby="contained-modal-title">
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title">
                    <i className="fas fa-upload" /> {i18n('Import data')}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <ImportBody>
                    {files ? (
                        <>{`${i18n('Are you sure you want to upload')} "${files[0].name}"?`}</>
                    ) : (
                        <>{type === 'risk-diagram' ? riskDiagramText : barrierText}</>
                    )}
                </ImportBody>
            </Modal.Body>
            <ImportFooter>
                {files ? (
                    <Button
                        className="no-outline-button"
                        bsStyle="primary"
                        type="button"
                        onClick={() => submit(files[0])}
                    >
                        {i18n('Confirm import')}
                    </Button>
                ) : (
                    <Button
                        className={`no-outline-button ${files ? '' : 'no-pad'}`}
                        bsStyle="primary"
                        type="button"
                        onClick={() => submit(files[0])}
                    >
                        <label className="control-label importLabel">
                            <i className="far fa-edit" />
                            {i18n(' Select .csv file')}
                            <input
                                type="file"
                                accept={
                                    type === 'bowtie'
                                        ? 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                                        : 'text/csv'
                                }
                                className="file-input"
                                onChange={e => setFiles(e.target.files)}
                            />
                        </label>
                    </Button>
                )}

                <Button className="no-outline-button" type="button" onClick={handleClose}>
                    {i18n('Cancel')}
                </Button>
            </ImportFooter>
        </RoundedModal>
    )
}
